import { Col } from "antd";
import styled from "styled-components";

export const WrapperColLogin = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
`;

export const WrapperLoginContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

export const LeftPanel = styled.div`
  flex: 1;
  background: linear-gradient(145deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -20%;
    right: -10%;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(233, 87, 53, 0.15) 0%, transparent 70%);
    border-radius: 50%;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 300px;
    background: linear-gradient(
      180deg,
      rgba(233, 87, 53, 0) 0%,
      rgba(233, 87, 53, 0.25) 50%,
      rgba(233, 87, 53, 0.5) 100%
    );
    filter: blur(80px);
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 80px 60px;
`;

export const LogoContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #E95735 0%, #ff8566 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  box-shadow: 0 4px 20px rgba(233, 87, 53, 0.3);
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 420px;
`;
